import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.min.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import money from 'v-money'
import 'vuetify/dist/vuetify.min.css'
import Chat from 'vue-beautiful-chat-stepan'
import VueLocalForage from 'vue-localforage'
import DatetimePicker from 'vuetify-datetime-picker'
import 'vuetify-datetime-picker/src/stylus/main.styl'
import 'lodash'

window.axios=axios

Vue.use(VueLocalForage)
Vue.use(Chat)

Vue.config.productionTip = false
Vue.use(DatetimePicker)
Vue.use(Vuetify)
Vue.use(money, {precision: 4})
Vue.use(Vuetify, {
    iconfont: 'fa4'
})


window.Event = new Vue;

export const UpdateNote = new Vue();


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
